"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _constant = require("../../constant");

var _utilities = _interopRequireDefault(require("../../../utilities"));

var _heroBannerPagination = _interopRequireDefault(require("./heroBannerPagination.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var PaginationContainer = _styledComponents.default.div.withConfig({
  displayName: "HeroBannerPagination__PaginationContainer",
  componentId: "pp1iin-0"
})(["display:flex;", ""], function (props) {
  return props.applyWidth && (0, _styledComponents.css)(["width:", "px;overflow:hidden;scroll-behavior:smooth;"], (_constant2.BANNER_PAGINATION_WIDTH + _constant2.BANNER_PAGINATION_MARGIN_RIGHT + _constant2.BANNER_PAGINATION_MARGIN_LEFT) * 5);
});

var Page = _styledComponents.default.div.withConfig({
  displayName: "HeroBannerPagination__Page",
  componentId: "pp1iin-1"
})(["width:", "px;height:", "px;border-radius:50%;margin:0 ", "px 0 ", "px;cursor:pointer;background-color:", ";flex:0 0 auto;opacity:0.3;", ""], _constant2.BANNER_PAGINATION_WIDTH, _constant2.BANNER_PAGINATION_HEIGHT, _constant2.BANNER_PAGINATION_MARGIN_RIGHT, _constant2.BANNER_PAGINATION_MARGIN_LEFT, function (_ref) {
  var theme = _ref.theme,
      pageColor = _ref.pageColor;
  return theme.colors[pageColor];
}, function (props) {
  return props.active && (0, _styledComponents.css)(["background-color:", ";opacity:1;"], function (_ref2) {
    var theme = _ref2.theme,
        activePageColor = _ref2.activePageColor;
    return theme.colors[activePageColor];
  });
});

var HeroBannerPagination = function HeroBannerPagination(props) {
  var pages = props.pages,
      activeIndex = props.activeIndex,
      onSelection = props.onSelection,
      pageColor = props.pageColor,
      activePageColor = props.activePageColor,
      accessible = props.accessible,
      theme = props.theme,
      fireGtm = props.fireGtm,
      pageAltTexts = props.pageAltTexts;
  var paginationContainerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      firstDotIndex = _useState2[0],
      setFirstDotIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(4),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      lastDotIndex = _useState4[0],
      setLastDotIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(pages),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      gtmCounter = _useState6[0],
      setGtmCounter = _useState6[1];

  var tabIndex;
  var applyInteraction = pages > 5;
  var dotOffsetWidth = _constant2.BANNER_PAGINATION_WIDTH + _constant2.BANNER_PAGINATION_MARGIN_RIGHT + _constant2.BANNER_PAGINATION_MARGIN_LEFT;
  var pageArr = []; // eslint-disable-next-line no-plusplus

  var _loop = function _loop(i) {
    if (!accessible) {
      tabIndex = '-1';
    } else if (i >= firstDotIndex && i <= lastDotIndex && accessible) {
      tabIndex = '0';
    } else {
      tabIndex = '-1';
    }

    pageArr.push( /*#__PURE__*/_react.default.createElement(Page, {
      key: i,
      role: "application",
      id: "heroBanner-pagination-".concat(i),
      "aria-label": "".concat(pageAltTexts && pageAltTexts[i], ". \n        Actionable Left click or press enter to proceed or press right left arrow to view the next banner."),
      tabIndex: tabIndex,
      active: i === activeIndex,
      pageColor: pageColor,
      activePageColor: activePageColor,
      onClick: function onClick() {
        return onSelection(i);
      },
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, function () {
          return onSelection(i);
        }, _constant.KEY_CODE.ENTER);
      }
    }));
  };

  for (var i = 0; i < pages; i++) {
    _loop(i);
  }

  (0, _react.useEffect)(function () {
    if (applyInteraction) {
      if (activeIndex === 0 && paginationContainerRef.current) {
        paginationContainerRef.current.scrollLeft = 0;
        setFirstDotIndex(0);
        setLastDotIndex(4);
      } else if (activeIndex === lastDotIndex) {
        paginationContainerRef.current.scrollLeft += dotOffsetWidth;
        setFirstDotIndex(firstDotIndex + 1);
        setLastDotIndex(activeIndex + 1);
      } else if (activeIndex === firstDotIndex && firstDotIndex > 0) {
        paginationContainerRef.current.scrollLeft -= dotOffsetWidth;
        setFirstDotIndex(firstDotIndex - 1);
        setLastDotIndex(lastDotIndex - 1);
      }
    }

    if (gtmCounter > 0) {
      // Triggers Gtm view event only once for all the banners
      if (fireGtm) fireGtm();
      setGtmCounter(gtmCounter - 1);
    } // if (onSelection) onSelection(activeIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [activeIndex]);

  var paginationKeydownHandler = function paginationKeydownHandler(key) {
    if (key === _constant.KEY_CODE.ARROW_LEFT) {
      var newIndex = activeIndex - 1;

      if (newIndex >= 0) {
        onSelection(newIndex);
        var page = document.getElementById("heroBanner-pagination-".concat(newIndex));

        if (page) {
          page.focus();
        }
      }
    } else if (key === _constant.KEY_CODE.ARROW_RIGHT) {
      var _newIndex = activeIndex + 1;

      if (_newIndex < pages) {
        onSelection(_newIndex);

        var _page = document.getElementById("heroBanner-pagination-".concat(_newIndex));

        if (_page) {
          _page.focus();
        }
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(PaginationContainer, {
    ref: paginationContainerRef,
    applyWidth: applyInteraction,
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, paginationKeydownHandler, [_constant.KEY_CODE.ARROW_LEFT, _constant.KEY_CODE.ARROW_RIGHT]);
    }
  }, pageArr));
};

HeroBannerPagination.propTypes = _heroBannerPagination.default.PropTypes;
HeroBannerPagination.defaultProps = _heroBannerPagination.default.DefaultProps;
var _default = HeroBannerPagination;
exports.default = _default;